import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import Event from '@oppobrowser/lib-browser-event';
import {
  $,
  $$,
  throttle,
  isDef,
  showToast,
  query,
  getQuery,
  getDataByPath as _get,
} from '@js/utils';
import {
  stat,
  getUserInfo,
  jumpGameCenter,
  bytesToSize,
  formatNumber,
} from '../../js/utils';
import template from './index.dot';
import { getGameResource, orderOrCancel } from '../../js/api';
import { STATUS_CODE, statusMap } from './constant';
import Feedback from '../../js/feedback.js';
import { getGameBottomData, nameMap } from './config.js';
import gameCardStore from './gameCardStore.js';
import wv from '@cpc/lib-browser-jsapi';
import './index.scss';

const enterMod = 'browser_article1';

const EventHandler = {
  // 处理游戏卡片点击
  async gameCardClick(node, e) {
    console.log('gameCardClick');
    e.stopPropagation();
    const gameData = this.data;
    console.log('gameData', gameData);

    if (gameData.pkgName) {
      const pkg_name = gameData.pkgName;
      const button_type = this.getAppBtnStatus();
      let open_result = 0;
      if (gameData.h5Url) {
        // 后台配置h5链接就跳转H5详情页
        wv.openDeepLink(gameData.h5Url);
        // window.open(gameData.h5Url);
        open_result = 1;
      } else {
        // 后台没配置H5链接就跳转dp链接
        // 用户安装了游戏中心就跳转游戏中心GameCenter
        const gameCenterResult = await jumpGameCenter([
          `oaps://gc/dt?pkg=${pkg_name}`,
        ]);
        if (gameCenterResult && gameCenterResult.data) {
          // 跳转成功
          open_result = 1;
        }
        // 否则就跳转软件商店DeepLink
        if (gameCenterResult && !gameCenterResult.data) {
          const openDpResult = wv.openDeepLink([
            `market://details?id=${pkg_name}&m=browser_article1`,
          ]);
          if (openDpResult) {
            open_result = 1;
          }
        }
      }

      // 埋点上报
      const commonInfo = this.getCommonInfo();
      const cardClickReportData = {
        resourceId: gameData.gameId,
        gameId: gameData.gameId,
        link_type: 2, // 1-H5链接，2-deeplink
        pkg_name, // 游戏应用包名
        button_type, // open-打开
        open_result, // 0-失败，1-成功
        ...commonInfo,
      };

      stat(20084266, 10012, 21006, cardClickReportData);
    }
  },
  gameBtnClick(node, e) {
    console.log('gameBtnClick');
    e.stopPropagation();
    const gameData = this.data;
    console.log('gameData', gameData);
    this.opt = {
      enterMod,
      pkg: gameData.pkgName,
      name: gameData.title || '',
      size: gameData.size || 0,
      icon: gameData.iconUrl || '',
      marketToken: gameData.backgroundAutomaticDownloadDynamicToken || '', // 鉴权Token
      marketDp: gameData.backupMarketDetailDeeplink || '', //  商店Dp
    };
    const reqData = {
      enterMod,
      appId: gameData.appId,
      pkg: gameData.pkgName,
    };

    if (gameData.status === 0) {
      // 如果按钮文字是“预约”
      const userInfo = getUserInfo();
      if (!userInfo || !Object.keys(userInfo).length) {
        return console.log('getUserInfo is', userInfo);
      }
      orderOrCancel('apply', reqData)
        .then((res) => {
          // 通知相同组件做状态更改 因为所有位置都是显示的同一个软件 所以无需检验包名
          gameData.status = 1; // 点了之后，改成“已预约”
          gameCardStore.callChangeBtnProgressFns({
            progress: '0%',
            width: '0%',
            innerHTML: '详情',
          });
          showToast('预约成功');
          // 上报预约成功
          this.clickBtnReport({ order_result: 1 }, 'order');
        })
        .catch((error) => {
          showToast('预约失败');
          // 上报预约失败
          this.clickBtnReport({ order_result: 0 });
          console.error(error);
        });
    } else if (gameData.status === 1) {
      // 如果按钮文字是“详情”
      this._eventHandler.gameCardClick(node, e);
      // 没有取消预约了 所以没有这个埋点
      // this.clickBtnReport({ order_cancel: 1 }, 'orderOff');
    } else {
      this.clickBtnReport();
      console.log('this.opt:  ', this.opt);

      let result;

      switch (this.btnStatus) {
        case STATUS_CODE.init:
        case STATUS_CODE.prepareDownload:
        case STATUS_CODE.unDownloaded: // 未下载，点击开始下载
          result = wv.download([this.opt]);
          console.log('wv.download result:', result);

          if (result && result.code === 0) {
            // 屏幕滚动出两屏不再展示浮窗 滚动事件需要三组件绑定同一个 否则 点击安装后清除滚动事件 无效
            window.removeEventListener('scroll', gameCardStore.scrollFunc);
            console.log('清除滚动监听: 游戏卡片');
            this.btnStatus = STATUS_CODE.downloading;
            this.showOrHideFloater('hideCardAni'); // 点击‘安装’之后，关闭浮窗
          }
          break;
        case STATUS_CODE.resume:
        case STATUS_CODE.downloading: // 下载中，点击暂停
          wv.onSync(this.opt, STATUS_CODE.pause);
          this.btnStatus = STATUS_CODE.pause;
          break;
        case STATUS_CODE.pause: // 暂停中，点击继续下载
          wv.onSync(this.opt, STATUS_CODE.resume);
          this.btnStatus = STATUS_CODE.downloading;
          break;
        case STATUS_CODE.downloaded: // 已下载，点击安装
          wv.onSync(this.opt, STATUS_CODE.installing);
          break;
        case STATUS_CODE.installed: // 已安装，点击打开
          wv.onSync(this.opt, STATUS_CODE.installed);
          break;
      }
    }
  },

  // 关闭悬浮卡
  closeFloatCard(node, e) {
    console.log('closeFloatCard');
    e.stopPropagation();
    this.showOrHideFloater('hideCardAni');
  },
  // 跳转链接
  linkUrl(node, e) {
    const url = node.dataset.href;
    console.log('linkUrl');
    e.stopPropagation();
    url && wv.openDeepLink(url);
  },
};
const docInfo = window.pageData.DOCINFO || {};

export default class GameOperation {
  constructor(el, name) {
    this.el = el;
    this.name = name; // 组件名称
    this._eventHandler = {};
    this.data = {};
    this.btnStatus = STATUS_CODE.init;
    this.opt = {};
    this.progress = 0;

    this._commonInfo = void 0; // 公共埋点字段
    this.screenHeight = 720; // 浏览器可视区域的高度
  }

  // 卡片文字按钮(安装,预约,详情)
  get btnDom() {
    return $('.game-operation-btn', this.el);
  }

  // 按钮文字dom  (安装,预约,详情)
  get btnTextDom() {
    return $('.game-operation-btn-text', this.btnDom);
  }

  // 按钮进度dom
  get btnAniDom() {
    return $('.ani', this.btnDom);
  }

  init() {
    if (!docInfo.keywords.includes('游戏')) return; // 非游戏类不请求也不渲染游戏卡片

    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();

    // 传入修改按钮的回调方法
    gameCardStore.receiveChangeBtnProgressFns(this.changeBtnProgress, this);

    gameCardStore.scrollFunc = this.scrollFunc = throttle(
      this.scrollFunc.bind(this),
      800,
    ); // 节流

    // 客户端不断调用这个方法回传下载进度，H5在里面的回调函数中进行按钮文字的改变
    setTimeout(() => {
      const sync = (pkgInfo, state, progress) => {
        console.log(
          'wv.sync pkgInfo: state: progress：',
          pkgInfo,
          state,
          progress,
        );
        console.log('this.data.pkgName', this.data.pkgName);
        if (pkgInfo.pkg === this.data.pkgName) {
          this.btnStatus = state;
          this.btnText(progress);
        }
      };
      const syncResult = wv.sync(sync);
      console.log('syncResult', syncResult);

      if (process.env.NODE_ENV === 'development') {
        // const testCase = require('./test/download'); // 测试用例
        // testCase.downloaded(sync, this.data.pkgName); // 下载完成
        // testCase.downloadPause(sync,this.data.pkgName);// 下载暂停
      }
    }, 500);

    this.getGameData();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  setBtnStatus(gameData) {
    if (!gameData.pkgName) {
      return console.log('没有包名,跳过查询');
    }
    const result = wv.queryDownloadState([
      [
        {
          pkg: gameData.pkgName,
        },
      ],
    ]);
    console.log('wv.queryDownloadState result:', result);
    if (result && result.data.length > 0) {
      this.btnStatus = result.data[0].status;
      this.progress = result.data[0].progress;
    }
  }

  changeBtnProgress({ progress, width, innerHTML }) {
    console.log(
      `change progress:${progress},width:${width},innerHTML:${innerHTML}`,
    );
    if (this.btnAniDom) {
      const _oldP = this.btnAniDom.dataset.progress;
      const _oldWidth = this.btnAniDom.dataset.width;
      if (isDef(progress) && progress != _oldP) {
        this.btnAniDom.dataset.progress = progress;
      }
      if (isDef(width) && width != _oldWidth) {
        this.btnAniDom.style.width = width;
        this.btnAniDom.dataset.width = width;
      }
    }
    if (this.btnTextDom) {
      isDef(innerHTML) &&
        this.btnTextDom.innerHTML !== innerHTML &&
        (this.btnTextDom.innerHTML = innerHTML);
    }
  }

  // 获取游戏数据
  getGameData() {
    // 数据回调 为了让顶部|底部|悬浮 三个组件 使用相同数据
    gameCardStore.getGameDataCallback((res) => {
      this.data = res;
      this.setBtnStatus(this.data);

      // 全文折叠 底部联运位置
      if (
        window.store.isShowFold &&
        window.store.isShowFold.isShow &&
        nameMap.gameOperationBottom == this.name
      ) {
        EventEmit.instance.on('showMore', () => {
          this.render();
        });
      } else {
        this.render();
      }
    }, this);
    if (gameCardStore.loading) {
      return;
    }
    gameCardStore.loading = 1;
    const searchParams = new URLSearchParams();
    searchParams.append(
      'gameTagList',
      JSON.stringify([
        {
          docId: docInfo.docId || '',
          label: docInfo.label || '',
          originLabel: docInfo.originLabel || '',
          title: docInfo.title || '',
        },
      ]),
    );

    // mock 数据
    if (process.env.NODE_ENV === 'development') {
      // Promise.resolve(require('./installGameMock.json'))
      // Promise.resolve(require('./orderGameMock.json'))
      // .then(res => JSON.parse(JSON.stringify(res)))
      // .then((res) => gameCardStore.receiveGameData(res, this))
      // return
    }
    getGameResource({ fromId: getQuery('__fromId__') }, searchParams)
      .then((res) => {
        console.log('searchParams=====', res);
        // 传输数据
        gameCardStore.receiveGameData(res, this);
      })
      .catch((error) => {
        console.log('searchParams==error', error);
        console.error(error);
      });
  }

  // 监听滚动
  watchScroll() {
    // 滚动事件需要三组件绑定同一个 否则 点击安装后清除滚动事件 无效
    this.screenHeight = window.screen.height;
    window.removeEventListener('scroll', gameCardStore.scrollFunc);
    window.addEventListener('scroll', gameCardStore.scrollFunc);
  }
  // 滚动回调函数
  scrollFunc(e) {
    const target = e.srcElement || e.target;
    const articleScrollTop = target.scrollingElement.scrollTop; // 文章滚出屏幕的高度
    // 滚出两屏弹出浮窗
    if (articleScrollTop >= this.screenHeight * 2) {
      console.log('清除滚动监听: 游戏卡片');
      window.removeEventListener('scroll', gameCardStore.scrollFunc);

      this.showOrHideFloater('showCardAni');
      setTimeout(() => {
        this.showOrHideFloater('hideCardAni');
      }, 10000);
    }
  }
  // 显隐浮窗
  showOrHideFloater(aniName) {
    const dom = $('.document-game--floater', this.el);
    dom && (dom.style.animationName = aniName);
  }

  // 按钮文字处理
  btnText(progress) {
    const el = this.btnDom;
    if (!el) return;
    const p = `${Math.ceil(progress)}%`;
    let text = '';

    switch (this.btnStatus) {
      case STATUS_CODE.init: // 0
        el.style.fontSize = '0.42rem'; // 字体14px
        if (this.data.status === 2) {
          // 下载完成，按钮显示'打开'，然后详情页进入后台，到桌面删除游戏，详情页再回到前台，按钮显示'安装'
          text = `${statusMap[this.btnStatus]}`; // 背景浅蓝，没有.ani
        } else if (this.data.status === 1) {
          // 正常进入详情页。游戏未上架，用户已预约
          text = '详情';
        } else {
          // 正常进入详情页。游戏未上架，用户可预约
          text = '预约';
        }
        this.changeBtnProgress({
          progress: '0%',
          width: '0%',
          innerHTML: text,
        });
        break;
      case STATUS_CODE.downloading: // 下载中，按钮显示进度值
        el.style.fontSize = '0.42rem'; // 字体14px
        this.changeBtnProgress({
          progress: p,
          width: p,
          innerHTML: p,
        });
        break;
      case STATUS_CODE.downloaded: // 完成
        el.style.fontSize = '0.42rem'; // 字体14px
        this.changeBtnProgress({
          progress: statusMap[this.btnStatus],
          innerHTML: statusMap[this.btnStatus],
        });
        break;
      case STATUS_CODE.pause: // 暂停，按钮显示'继续'
        el.style.fontSize = '0.42rem'; // 字体14px
        this.changeBtnProgress({
          progress: statusMap[this.btnStatus],
          width: p,
          innerHTML: statusMap[this.btnStatus],
        });
        break;
      case STATUS_CODE.installing: // 按钮显示'安装中'
        el.style.fontSize = '0.36rem'; // 字体12px
        this.changeBtnProgress({
          progress: statusMap[this.btnStatus],
          innerHTML: statusMap[this.btnStatus],
          width: '100%',
        });
        break;
      case STATUS_CODE.installed: // 按钮显示'打开'
        el.style.fontSize = '0.42rem'; // 字体14px
        this.changeBtnProgress({
          progress: statusMap[this.btnStatus],
          innerHTML: statusMap[this.btnStatus],
          width: '100%',
        });
        break;
    }
  }

  // 卡片曝光监听
  exposedCardReport() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item.isIntersecting && !item.target.dataset.reported) {
          item.target.dataset.reported = 1;
          const gameData = this.data;
          const btnStatus = this.getAppBtnStatus();
          const commonInfo = this.getCommonInfo();
          const reportData = {
            resourceId: gameData.gameId,
            link_type: 2,
            button_type: btnStatus,
            pkg_name: gameData.pkgName,
            gameId: gameData.gameId,
            ...commonInfo,
          };
          stat(20084339, 10012, 21006, reportData);
        }
      });
    });

    const dom =
      $('.document-game', this.el) || $('.document-game--floater', this.el);
    dom && observer.observe(dom);
  }
  // 按钮点击曝光
  clickBtnReport(other, adjust) {
    const gameData = this.data;
    let btnStatus = this.getAppBtnStatus();
    let commonInfo = this.getCommonInfo();
    let reportData = {
      resourceId: gameData.gameId,
      link_type: 2,
      button_type: adjust ? adjust : btnStatus,
      pkg_name: gameData.pkgName,
      gameId: gameData.gameId,
      ...commonInfo,
      ...other,
    };
    stat(20084265, 10012, 21006, reportData);
  }

  // 获得当前app按钮状态-用于埋点上报
  getAppBtnStatus() {
    let statusStr = '';
    switch (this.btnStatus) {
      case STATUS_CODE.init: // 0
        if (this.data.status === 2) {
          // download 点击开始下载
          statusStr = 'download';
        } else if (this.data.status === 1) {
          // orderoff 点击取消预约
          statusStr = 'orderOff';
        } else {
          //order 点击预约
          statusStr = 'order';
        }
        break;
      case STATUS_CODE.downloading:
        // pause 点击暂停
        statusStr = 'downloading';
        break;
      case STATUS_CODE.pause:
        // downloading 点击继续下载
        statusStr = 'pause';
        break;
      case STATUS_CODE.installed:
        // open 点击打开
        statusStr = 'open';
        break;
    }
    return statusStr;
  }

  // 获得公共字段
  getCommonInfo() {
    if (this._commonInfo) {
      return this._commonInfo;
    }
    let browserInfo = {};
    if (window.BrowserPriv && window.BrowserPriv.getBrowserInfo) {
      try {
        browserInfo = JSON.parse(window.BrowserPriv.getBrowserInfo());
      } catch (e) {
        console.log('json解析失败', e);
        return {};
      }
      this._commonInfo = {
        imei: browserInfo.imei,
        ssoid: `${browserInfo.duid},${browserInfo.ouid}`,
        brand: browserInfo.brand,
        model: browserInfo.mobileName,
      };
      return this._commonInfo;
    }
    return {};
  }

  _render() {
    const gameData = this.data;
    const formatPlayerNum =
      gameData.playerNum > 1000
        ? `${formatNumber(gameData.playerNum)}人${
            gameData.status === 2 ? '在玩' : '预约'
          }`
        : '';
    const data = {
      ...gameData,
      grade: (+gameData.grade || 0).toFixed(1),
      size: bytesToSize(gameData.size, 1),
      formatPlayerNum,
      gameBoxBottomData: getGameBottomData({
        versionName: _get(gameData, 'adGovFourItem.versionName', ''),
        developer: _get(gameData, 'adGovFourItem.developer', ''),
        privacyJump: _get(gameData, 'adGovFourItem.privacyJump', ''),
        permissionJump: _get(gameData, 'adGovFourItem.permissionJump', ''),
      }),
    };
    console.log('data', data);

    this.el.innerHTML = template({
      ...data,
      name: this.name,
    });

    // 按压反馈
    this.feedback = $$('.feedback', this.el).map((el) => new Feedback(el));

    // 每次进入同一个游戏的页面，根据游戏状态和进度显示按钮文案
    this.btnText(this.progress);

    this.exposedCardReport();

    EventEmit.instance.emit('component-loaded', 'gameOperation', {
      data: this.data,
    });
  }

  render() {
    if (!this.data || !Object.keys(this.data).length || !this.data.pkgName) {
      return;
    }

    // 渲染逻辑
    const showSite = this.data.showSite;
    // showSite: 0-底部，1-顶部,2-底部和顶部都有,null-没有勾选不展示
    switch (this.name) {
      case nameMap.gameOperationTop:
        if ([1, 2].includes(showSite)) {
          this._render();
        }
        break;
      case nameMap.gameOperationBottom:
        if ([0, 2].includes(showSite)) {
          this._render();
        }
        break;
      // 由客户端来渲染悬浮应用
      // case nameMap.gameOperationFloat:
      //   if (this.data.floater) {
      //     this._render();
      //   }
      //   this.watchScroll();
      //   break;
      default:
        console.error('游戏卡片组件匹配错误');
        break;
    }
  }
}
